<template>
	<section class="container_main-content" v-if="show">
		<h1 class="heading heading-title">Tvá rezervace</h1>
		<div class="icon__divider">
			<span class="icon icon__divider-outer">
				<span class="icon icon__divider-inner"></span>
			</span>
		</div>
		<article class="booking-overview">
			<div class="booking-overview__wrapper flex-vertical">
				<div class="booking-overview__section booking-overview__textarea" v-if="booking.state === 'new'">
					<!-- <div class="booking-overview__section-wrapper"> -->
					<!-- <div class="divider__horizontal"></div> -->
					<div class="appointment__message">
						<h2 class="appointment__message-heading heading-content-title">Děkujeme za rezervaci!</h2>
						<p class="appointment__message-content heading-caption">
							Nezapomeň rezervaci do <span class="bold">60 minut</span> potvrdit kliknutím na odkaz v emailu, který ti za chvíli přijde.
						</p>
					</div>
					<!-- </div> -->
				</div>
				<div class="booking-overview__section booking-overview__status">
					<h1
						class="content-box content-box__status content-box__status-big content-box-secondary heading-subtitle centered"
						:class="`status-${booking.state}`"
					>
						{{ $t(`booking.state.${booking.state}`) }}
					</h1>
				</div>
				<div class="booking-overview__section booking-overview__header content-box-primary content-box-primary-bold background-lightgray">
					<div class="booking-overview__section-wrapper">
						<div class="booking-overview__appointment heading-content-title flex-horizontal">
							<div class="appointment__time flex-vertical">
								<span class="appointment__details appointment__details-header">čas:</span>
								<span class="appointment__details appointment__details-content-big">{{ date.format('H:mm') }}</span>
							</div>
							<div class="appointment__date flex-vertical">
								<span class="appointment__details appointment__details-header">datum:</span>
								<span class="appointment__details appointment__details-content-big">{{ date.format('DD/MM') }}</span>
								<span class="appointment__details appointment__details-content-small">{{ date.format('dddd') }}</span>
							</div>
						</div>
						<h2 class="booking-overview__section-title booking-bold heading-section">Služba:</h2>
						<h3 class="appointment__service center-align">{{ firstService.name }}</h3>
						<h4 class="appointment__provider">{{ booking.barber.name }}</h4>
					</div>
				</div>
				<div class="booking-overview__section booking-overview__content" v-if="booking.services.length > 0">
					<div class="booking-overview__section-wrapper">
						<h2 class="booking-overview__section-title booking-bold heading-section">Doplňky:</h2>
						<div class="booking-overview__services">
							<ul class="appointment__services">
								<li class="appointment__services-item" v-for="(service, i) in booking.services" :key="i">{{ service.name }}</li>
							</ul>
						</div>
					</div>
				</div>
				<div class="booking-overview__section background-lightgray">
					<div class="appointment__price flex-horizontal booking-overview__section-wrapper">
						<span class="service-price booking-regular">Cena celkem:</span>
						<span class="service-price booking-regular-nc">{{ $n(booking.price, 'currency') }}</span>
					</div>
				</div>
				<div class="booking-overview__section booking-overview__controls" v-if="booking.can_user_cancel && !summary">
					<button class="button button-plain content-default centered" type="button" @click="cancelConfirm">Zrušit rezervaci</button>
				</div>
			</div>
		</article>
	</section>
</template>

<script>
export default {
	name: 'Booking',

	props: {
		data: {
			type: Object,
			required: true,
		},
		summary: {
			type: Boolean,
			default: false,
		},
	},

	data() {
		return {
			show: false,
			booking: {},
			firstService: {},
		}
	},

	created() {
		this.booking = this._.cloneDeep(this.data)
		this.firstService = this.booking.services[0]
		this.booking.services = this._.drop(this.booking.services)
		this.show = true
	},

	computed: {
		date() {
			return this.$moment(this.booking.date)
		},
	},

	methods: {
		cancelConfirm() {
			this.$modal('components/bookingCancelConfirm', {}, { close: () => this.cancel() })
		},
		async cancel() {
			let { data } = await this.$http.delete(this.booking.cancel_url)
			this.booking = data
		},
	},
}
</script>
